import { Button } from "../ui/button";
import { handleLinkClick, generateLink } from "lib/links";
import { Pages } from "types/common";
import { useAtomValue } from "lib/global-context";
import { userIdAtom } from "lib/atoms";
import styles from "./cta-banner.module.css";
import { cn } from "lib/utils";

const CtaBanner = ({ page }: { page: Pages }) => {
  const userId = useAtomValue(userIdAtom);

  return (
    <div
      className={cn(
        styles.container,
        page === "retirement" && styles.retirementContainer,
      )}
    >
      <div className={styles.text}>
        {page === "retirement"
          ? "Retirement costs less when your money works harder. Find out how and get S$20 cash!"
          : "Schedule a free Financial Health Check with our Etiqa Assurance Managers today and enjoy a S$20 cash reward - no purchase needed!"}
      </div>
      <a
        onClick={(e) => handleLinkClick(e, page, userId)}
        href={generateLink("contactus", page)}
        target="_top"
        className={styles.link}
      >
        <Button>Claim now</Button>
      </a>
    </div>
  );
};

export default CtaBanner;
